/**
 * Banner Parallax Animation
 * - Built for site-wide Lenis smoothing
 * - Background and content move at different rates
 * - No per-element easing hacks
 * - Responsive and performant
 */

(function() {
  'use strict';

  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (isReducedMotion) return;

  function ensureGSAPLoaded() {
    return new Promise(function(resolve) {
      if (typeof window.gsap !== 'undefined') {
        if (typeof window.ScrollTrigger !== 'undefined') {
          window.gsap.registerPlugin(window.ScrollTrigger);
          resolve();
        } else {
          loadScrollTrigger(resolve);
        }
      } else {
        loadGSAP(function() {
          loadScrollTrigger(resolve);
        });
      }
    });
  }

  function loadGSAP(callback) {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    script.async = true;
    script.onload = callback;
    script.onerror = function() {
      console.error('Failed to load GSAP');
    };
    document.head.appendChild(script);
  }

  function loadScrollTrigger(callback) {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
    script.async = true;
    script.onload = function() {
      window.gsap.registerPlugin(window.ScrollTrigger);
      callback();
    };
    script.onerror = function() {
      console.error('Failed to load ScrollTrigger');
    };
    document.head.appendChild(script);
  }

  function destroyBannerParallax(banner) {
    if (!banner) return;

    if (banner._parallaxTimeline) {
      banner._parallaxTimeline.kill();
      banner._parallaxTimeline = null;
    }

    if (banner._parallaxTrigger) {
      banner._parallaxTrigger.kill();
      banner._parallaxTrigger = null;
    }

    const media = banner.querySelector('.banner__media');
    const contentBox = banner.querySelector('.banner__box') || banner.querySelector('.banner__content');

    if (typeof window.gsap !== 'undefined') {
      if (media) {
        window.gsap.killTweensOf(media);
        window.gsap.set(media, { clearProps: 'transform' });
      }

      if (contentBox) {
        window.gsap.killTweensOf(contentBox);
        window.gsap.set(contentBox, { clearProps: 'transform' });
      }
    }

    banner.dataset.parallaxInitialised = 'false';
  }

  function initialiseParallax() {
    const banners = document.querySelectorAll('[id^="Banner-"][data-parallax]');

    if (banners.length === 0) return;

    banners.forEach(function(banner) {
      if (banner.dataset.parallaxInitialised === 'true') {
        return;
      }

      const media = banner.querySelector('.banner__media');
      const contentBox = banner.querySelector('.banner__box') || banner.querySelector('.banner__content');

      if (!media || !contentBox) {
        return;
      }

      try {
        window.gsap.set(media, {
          y: 0,
          force3D: true
        });

        window.gsap.set(contentBox, {
          y: 0,
          force3D: true
        });

        const timeline = window.gsap.timeline({
          defaults: {
            ease: 'none'
          },
          scrollTrigger: {
            trigger: banner,
            start: 'top top',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true
          }
        });

        timeline.to(media, {
          y: function() {
            return window.innerHeight * 0.12;
          },
          force3D: true
        }, 0);

        timeline.to(contentBox, {
          y: function() {
            return window.innerHeight * 0.22;
          },
          force3D: true
        }, 0);

        banner._parallaxTimeline = timeline;
        banner._parallaxTrigger = timeline.scrollTrigger;
        banner.dataset.parallaxInitialised = 'true';
      } catch (error) {
        console.error('Error initialising parallax on banner:', error);
      }
    });

    if (!window.__bannerParallaxResizeBound) {
      window.addEventListener('resize', function() {
        if (window.ScrollTrigger) {
          window.ScrollTrigger.refresh();
        }
      });
      window.__bannerParallaxResizeBound = true;
    }
  }

  ensureGSAPLoaded().then(initialiseParallax);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      if (!e.detail.sectionId) return;

      const banner = document.getElementById('Banner-' + e.detail.sectionId);
      if (!banner) return;

      destroyBannerParallax(banner);
      ensureGSAPLoaded().then(initialiseParallax);
    });

    document.addEventListener('shopify:section:unload', function(e) {
      if (!e.detail.sectionId) return;

      const banner = document.getElementById('Banner-' + e.detail.sectionId);
      if (!banner) return;

      destroyBannerParallax(banner);
    });
  }
})();